import React from 'react';
import { withTheme } from '../core/theming';

import Div from './Div';

/* eslint-disable react/prop-types */

const Row = ({ theme, ...rest }) => (
  <Div m={{ y: 0, x: `calc(-${theme.grid.gutterWidth}/2)` }} {...rest}>
    {rest.children}
  </Div>
);

/* eslint-enable react/prop-types */

Row.defaultProps = {
  d: 'flex',
  flexWrap: 'wrap',
};

export default withTheme(Row);
